import {
  request,
  response,
  requestPostUrl,
  requestGET,
  requestGetMethod,
  requestLoyaltyWS,
  responseLoyaltyWS,
} from './functions';

export function getListMyGift(eposGiftInfofr) {
  const req = requestLoyaltyWS('POST', {}, eposGiftInfofr);
  return responseLoyaltyWS('loyalty/GiftInfors/GetAllByMemberCode', req);
}

export function getListMyGiftPaServ(eposGiftInfofr) {
  const req = requestLoyaltyWS('POST', {}, eposGiftInfofr);
  return responseLoyaltyWS('loyalty/GiftTransactions/GetAllWithEGift', req);
}

export function getAllForCategoryServ(category) {
  const req = request(category);
  return response('loyalty/GiftInfors/GetAllForCategory', req);
}
export function getAllWithImageServ() {
  const req = requestGetMethod();
  return response('loyalty/GiftGroups/GetAllWithImage', req);
}

export function createRedeemTransaction(obj) {
  const req = requestLoyaltyWS('POST', {}, obj);
  return responseLoyaltyWS('loyalty/GiftTransactions/CreateRedeemTransaction', req);
}

export function updateStatusGiftInforServ(eposGiftInfofr) {
  const req = requestLoyaltyWS('POST', {}, eposGiftInfofr);
  return responseLoyaltyWS('loyalty/EGiftInfors/UpdateUsedStatus', req);
}

export function getListMenuCategoryServ(memberCode) {
  const req = requestLoyaltyWS('GET');
  return responseLoyaltyWS('loyalty/GiftCategory/GetAllByMemberCode?memberCode=' + memberCode, req);
}

export function getListGiftWithType(params) {
  const req = requestLoyaltyWS('POST', {}, params);
  return responseLoyaltyWS('loyalty/GiftInfors/GetGiftCategoriesAndGiftInfors', req);
}

export function getTransactionPointHistory(params) {
  const req = requestLoyaltyWS('POST', {}, params);
  return responseLoyaltyWS('loyalty/Transactions/GetTransactionPointHistory', req);
}

export function getCityCodeServ(reqs) {
  const req = request(reqs);
  return response('public/getAddressVillage', req);
}

export function saveLog(reqs) {
  const req = requestLoyaltyWS('POST', {}, reqs);
  return responseLoyaltyWS('loyalty/log', req);
}

export function getProfileByCGifServ(userCode) {
  const req = requestLoyaltyWS('GET', { code: userCode });
  return responseLoyaltyWS('loyalty/SecondaryCustomers/GetProfileByCode', req);
}

export function getDetailGiftServ(memberCode) {
  const req = request(memberCode);
  return response('loyalty/GiftInfors/GetGiftByMemberCode', req);
}

export function checkMiniGameServ() {
  const req = requestGET();
  return response('loyalty/checkMiniGame', req);
}
